export default "__VITE_ASSET__BvEuHpAl__"